import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useNotificationsStore } from 'ah-notifications/src/store';
import NotificationsTooltip from 'bd-common/src/components/notifications/NotificationsTooltip.vue';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import UserIconMenu from 'bd-common/src/components/user/UserIconMenu.vue';

type NotificationsStoreType = {
  unreadCount: number;
  fileExportUnreadCount: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateTopNav',
  setup(__props) {

const notificationsTooltip = ref<InstanceType<typeof NotificationsTooltip> | null>(null);
const fileExportsTooltip = ref<InstanceType<typeof NotificationsTooltip> | null>(null);

const notificationsStore = useNotificationsStore();

const hasUnreadNotifications = computed(() => notificationsStore.unreadCount > 0);

const hasUnreadFileExports = computed(() => notificationsStore.fileExportUnreadCount > 0);

const notificationCount = (property: keyof NotificationsStoreType) => {
  return computed(() => {
    const count = notificationsStore[property];
    return count > 99 ? '99+' : count;
  });
};

const notificationNumber = notificationCount('unreadCount');
const fileExportNumber = notificationCount('fileExportUnreadCount');

function showNotificationsTooltip() {
  notificationsTooltip.value?.show();
}

function showFileExportsTooltip() {
  fileExportsTooltip.value?.show();
}

return { __sfc: true,notificationsTooltip, fileExportsTooltip, notificationsStore, hasUnreadNotifications, hasUnreadFileExports, notificationCount, notificationNumber, fileExportNumber, showNotificationsTooltip, showFileExportsTooltip, NotificationsTooltip, MaterialIcon, UserIconMenu }
}

})